import { FC } from "react";
import { Box, styled } from "@mui/system";
import muiIcons from "../icons/mui-icons";
import { H3, H4 } from "../Typography";
import { GullButton } from "../buttons/GullButton";
import { CardContainer } from "../CardContainer";

const counterBoxData = [
  {
    name: "Net Earning",
    count: "$5,299",
    Icon: muiIcons.DownArrowIcon,
  },
  {
    name: "Canceled",
    count: "16%",
    Icon: muiIcons.UpArrowIcon,
  },
  {
    name: "Charge",
    count: "$700",
    Icon: muiIcons.DownArrowIcon,
  },
];

const CounterBox = styled(Box)<{ index: number }>(({ theme, index }) => ({
  margin: ".4rem",
  padding: ".5rem 1rem",
  borderRadius: "5px",
  border: `1px dashed ${theme.palette.grey[300]}`,
  "& h3": {
    "& svg": {
      fontSize: 12,
      marginLeft: "5px",
      color:
        index === 1 ? theme.palette.error.main : theme.palette.success.main,
    },
  },
  "& h4": {
    color: theme.palette.grey.main,
  },
}));

const StatementBody = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    display: "block",
  },
}));

const StatementCard: FC = () => {
  return (
    <CardContainer>
      <H3 sx={{ mx: ".4rem" }}>Earnings Details</H3>
      <H4 sx={{ m: ".4rem", py: "10px", color: "#9e9e9e" }}>
        Last 30 day earnings calculated by the sales. Lorem ipsum is a
        placeholder
      </H4>
      <StatementBody>
        <Box display="flex">
          {counterBoxData.map((data, index) => (
            <CounterBox index={index}>
              <H3>
                {data.count}
                <data.Icon />
              </H3>
              <H4>{data.name}</H4>
            </CounterBox>
          ))}
        </Box>
        <GullButton variant="outlined" color="primary">
          Balance Withdraw
        </GullButton>
      </StatementBody>
    </CardContainer>
  );
};

export default StatementCard;
